import { Card } from "semantic-ui-react";
import { NewListPageComponent } from "../components/page/NewListPageComponent";
import { getSession } from "../helper";
import { CREATE_ROUTINE, LIST_ROUTINES } from "./queries";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import { getRoutineForm } from "./routine_form";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";

const card = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid key={props.data.id}>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <Card.Header style={{ fontSize: 18 }}>
            <b>{props.data.name}</b>
          </Card.Header>
          <CardDotMenuComponent
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
            cardData={props.data}
            props={{
              menuItems: [],
            }}
          />
        </div>
      </Card.Content>
      <Card.Content>
        {props.data.routineItems.map((item: any) => (
          <div key={item.id} className="routine-item">
            {item.name}
          </div>
        ))}
      </Card.Content>
    </Card>
  );
};

export const RoutinePage = () => {
  return (
    <NewListPageComponent
      props={{
        type: "list_page",
        query: LIST_ROUTINES,
        queryVariables: { session: getSession() },
        itemName: "Routine",
        card: card,
        creationProps: {
          formComponentProps: new NewNewFormComponentProps({
            form: getRoutineForm(),
            startingData: { name: "", routineItems: [] },
          }),
          apiCall: CREATE_ROUTINE,
        },
      }}
    />
  );
};
